export const getBSOatsOatmealPackage = newProduct => {
  const newBSOatsOatmealPackage = {
    UPC: newProduct.UPC,
    OatType: newProduct.OatType,
    OtherType: newProduct.OtherType,
    Size: newProduct.Size,
    Variety: newProduct.Variety,
    OtherVariety: newProduct.Variety,
    CookingType: newProduct.CookingType,
  }
  return newBSOatsOatmealPackage
}

export const updateBSOatsOatmealPackage = newProduct => {
  const newBSOatsOatmealPackage = {
    UPC: newProduct.UPC,
    OatType: newProduct.OatType,
    OtherType: newProduct.OtherType,
    Size: newProduct.Size,
    Variety: newProduct.Variety,
    OtherVariety: newProduct.Variety,
    CookingType: newProduct.CookingType,
  }
  return newBSOatsOatmealPackage
}
